<header>
  <div class="m-header" [style.display]="this.headerStyle">
    <a class="mobile-menu" id="mobile-collapse1" href="javascript:" (click)="this.NavCollapsedMob.emit()"><span></span></a>
    <a [routerLink]="['/']" class="b-brand">
      <div class="b-bg">
        <span class="logo-lg"><img src="assets/images/logo-sm.png" alt="" height="25"></span>
      </div>
      <span class="b-title">Accounts Productions</span>
    </a>
  </div>
  <a class="mobile-menu" [ngClass]="{ on: this.menuClass }" id="mobile-header" href="javascript:" (click)="toggleMobOption()">
    <i class="feather icon-more-horizontal"></i>
  </a>
  <div class="card collapse navbar-collapse px-4" [style.display]="this.collapseStyle" style="box-shadow: none; margin-bottom: 15px;">
    <app-nav-left class="me-auto" [style.display]="this.headerStyle"></app-nav-left>
    <app-nav-right class="ms-auto"></app-nav-right>
   

  </div>
</header>





